import { useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { createStudent } from "../controllers/studentController";
import {
  buildStudentPayload,
  emptyStudentForm,
  getStudentErrorMessage,
  normalizeCreatedStudentResponse,
} from "../utils/studentUtils";
import { getLmsRole, isParentRole } from "../../utils/lmsRole";
import StudentCredentialsCard from "../components/StudentCredentialsCard";
import StudentForm from "../components/StudentForm";
import { StudentsWrapper } from "../styles/StudentsStyle";

const CreateStudentPage = () => {
  const [formData, setFormData] = useState(emptyStudentForm);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [createdCredentials, setCreatedCredentials] = useState(null);
  const { credObj } = useSelector((store) => store.auth);
  const { currentUser } = useSelector((store) => store.users);
  const role = getLmsRole({ currentUser, credObj });
  const isParent = isParentRole(role);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setError("");
    setCreatedCredentials(null);

    try {
      const response = await createStudent(buildStudentPayload(formData));
      const { credentials } = normalizeCreatedStudentResponse(response);
      setCreatedCredentials(credentials);
      setFormData(emptyStudentForm);
    } catch (err) {
      setError(getStudentErrorMessage(err.message));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <StudentsWrapper>
      <section className="student-page-card">
        <div className="student-page-heading">
          <p className="eyebrow">{isParent ? "Create Kid" : "Create Student"}</p>
          <h1>{isParent ? "Add a kid profile" : "Add a learner profile"}</h1>
          <p>{isParent ? "The kid code and PIN will be emailed after creation." : "The student code and PIN will be emailed after creation."}</p>
        </div>

        {createdCredentials && <StudentCredentialsCard credentials={createdCredentials} isParent={isParent} />}
        {error && <p className="students-error" role="alert">{error}</p>}

        <StudentForm
          formData={formData}
          onChange={handleChange}
          onSubmit={handleSubmit}
          submitLabel={isParent ? "Create Kid" : "Create Student"}
          isSubmitting={isSubmitting}
          secondaryAction={<Link to="/dashboard/students" className="student-secondary-action">Cancel</Link>}
        />
      </section>
    </StudentsWrapper>
  );
};

export default CreateStudentPage;
